import Store from '@/store'

export class InboxStoreUtils {

    static fetchInboxes() {
        return Store.dispatch("inbox-store/fetchInboxes");
    }

    static deleteInbox(key) {
        return Store.dispatch("inbox-store/deleteInbox", key);
    }

    //GETTERS
    static getInboxes() {
        return Store.getters["inbox-store/getInboxes"];
    }
}